export default import.meta.ROLLDOWN_FILE_URL_UiXUcgPxVrXjan1d0C9YbA